import { useEffect, useState } from 'react';
import { apiUrl } from '../../../api/apiUrl';
import http from '../../../api/axios';
import DataTable from '../../../components/table/DataTable';
import { Company } from '../../../types/Company';
import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../components/button/Button';
import { toast } from 'react-toastify';
import { columns } from '../../../components/columns/Company/UserCompaniesColumns';
import { paths } from '../../RouterContainer';
import { useTranslation } from '../../../context/translationContext';
import { PlusIcon } from '@heroicons/react/24/outline';
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs';

/**
 * Page component represents Companies overview for current user
 */
export const UserCompaniesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<Company[] | null>(null);
  const { setBreadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    setBreadcrumbs([{ path: `${paths.MY_COMPANIES}`, name: 'navigation.my-companies' }]);
  }, []);

  /**
   * Loads user companies
   */
  const fetchCompanies = async () => {
    const response = await http.apiGet({ url: apiUrl.COMPANY_GET_USERS_COMPANIES });
    setCompanies(response?.data);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  /**
   * Removes company
   * @param id of company
   */
  const onRemoveItem = async (id: string | number) => {
    if (id === null) return;
    const response = await http.apiDelete({ url: `${apiUrl.COMPANY_DELETE}?id=${id}` });
    if (response?.status === 204) {
      toast.success('Success!');
      fetchCompanies();
    }
  };

  /**
   * Redirects to company edit page
   * @param id of company
   */
  const onEditItem = (id: string | number) => {
    if (id === null) return;
    navigate(`/${paths.MY_COMPANIES}/edit/${id}`, { state: id });
  };

  return (
    <>
      <div className="flex justify-between">
        <h1 className="text-3xl font-bold">{t('page.company.headline-my-list')}</h1>
        <Link to={`/${paths.MY_COMPANIES}/create`}>
          <Button
            title={t('general.create-new')}
            color="green"
            icon={<PlusIcon className="w-4 h-4 mr-2" />}
          />
        </Link>
      </div>

      <p>Přehled všech společností přihlášeného uživatele.</p>

      <DataTable
        data={companies}
        columns={columns}
        handleRemove={onRemoveItem}
        handleEdit={onEditItem}
      />
    </>
  );
};
